/**
 * Academy Reducers
 */
import {
    ALL_ACADEMYS,
    ALL_ACADEMYPROGRAM,
    ACADEMY_PROGRAM_ACTION,
    ADD_ACADEMY_PROGRAM,
    EDIT_ACADEMY_PROGRAM,
    STATUS_ACADEMY_PROGRAM,
    DELETE_ACADEMY_PROGRAM

} from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    academyprogramlists: [],
    academylists:[],
    loading: false
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ACADEMY_PROGRAM_ACTION:
            return { ...state, loading: true };

        case ALL_ACADEMYPROGRAM:
            return { ...state, loading: false, academyprogramlists: action.payload };

            case ALL_ACADEMYS:
                return { ...state, loading: false, academylists: action.payload };  

        case ADD_ACADEMY_PROGRAM:
            return { ...state, loading: false };

        case EDIT_ACADEMY_PROGRAM:
            return { ...state, loading: false };

        case STATUS_ACADEMY_PROGRAM:
            return { ...state, loading: false };

        case DELETE_ACADEMY_PROGRAM:
            return { ...state, loading: false };


        default: return { ...state };
    }
}